<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-12">
                <h1>
                    <i class="fas fa-cogs text-primary"></i> {{$t('part.title')}}
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="h5 mb-4">
                    <a
                        href
                        class="badge badge-primary text-white mr-1"
                        @click.prevent="setCatId('')"
                    >{{$t('part.categories.all')}}</a>
                    <a
                        href
                        v-for="(cat, i) in categories"
                        class="badge badge-primary text-white mr-1"
                        @click.prevent="setCatId(cat.id)"
                    >{{$t('part.categories.' + cat.name.toLowerCase())}}</a>
                </div>
                <div class="row">
                    <Item v-for="item in forSale" :key="item.id" :product="item" />
                </div>
            </div>
            <div v-if="showCart" class="col" style="max-width:400px;min-width:300px;">
                <slot v-if="isAdmin() && showAsfSelection">
                    <card class="card" :title="$t('part.text.chooseasf')" style="z-index: auto">
                        <div class="card-body border-top">
                            <multiselect
                                v-model="value"
                                :options="asfs"
                                :custom-label="asfLabel"
                                :placeholder="$t('part.text.selectone')"
                                label="name"
                                track-by="id"
                                @open="getAsfs"
                                @input="selectAsfs"
                            ></multiselect>
                        </div>
                    </card>
                </slot>
                <ShoppingCart :showButtons="true" :showRequestButton="showReqButton" :cart_title="$t('part.titlerequest')" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Item from "./Item.vue";
import ShoppingCart from "./ShoppingCart.vue";

export default {
  name: "Parts",
  props: {
    showCart: {
      type: Boolean,
      default: true
    },
    showReqButton: {
      type: Boolean,
      default: true
    },
    showAsfSelection: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      catId: "",
      value: ""
    };
  },
  computed: {
    ...mapState("asfs", {
      asfs: "all"
    }),
    requestButton() {
      return this.showReqButton;
    },
    all() {
      return this.$store.getters["cart/all"];
    },
    categories() {
      return this.$store.getters["cart/categories"];
    },
    forSale() {
      // console.log('this.catId');
      // console.log(this.catId);
      if (!this.catId) return this.all;
      return this.all.filter(item => {
        return item.categories
          .map(o => o["id"])
          .join(", ")
          .includes(this.catId);
      });
    },
    currentAsf() {
      return this.$store.getters["auth/getCurrentAsf"];
    },
    pageIs() {
      if (window.location.pathname.includes("parts") || window.location.pathname.includes("requests")) return "requests";
      if (window.location.pathname.includes("repair")) return "repair_status";
    }
  },
  methods: {
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAsfs(option) {
      this.$store.commit("auth/setCurrentAsf", option.id);
    },
    setCatId(catId) {
      this.catId = catId;
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs");
    }
  },
  components: {
    Item,
    ShoppingCart
  },
  console: () => console,
  mounted() {
    this.$store.commit("cart/clearCart");
    this.$store.dispatch("cart/getAllParts", this.pageIs);
    this.$store.dispatch("cart/getAllCategories");
  }
};
</script>
